import { render } from "./PartnershipProgram.vue?vue&type=template&id=25d7d8fd"
import script from "./PartnershipProgram.vue?vue&type=script&lang=js"
export * from "./PartnershipProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__